import React from "react";
import { Dropdown } from "semantic-ui-react";

import Checkbox from "@cayuse/shared-react.components.form.inputs.checkbox";

import styles from "containers/Form/SimplifiedBuilder/Components/ResearchTeamComponent.css";
import { useDictionary } from "hooks";

const DEFAULT_DICTIONARY = {
	externalResearchersTitle: "Allow External Researchers",
	externalResearchersDescription: "Allow External Researchers",
	allowNewPerson: "Allow creation of new external researchers",
	creditFieldTitle: "Display Credit Field",
	creditFieldDescription: "Display Credit Field",
	creditFieldRequiredTitle: "Credit Field required",
	creditFieldRequiredDescription: "Credit Field required",
	sponsoredEffortTitle: "Display Sponsored Effort",
	sponsoredEffortDescription: "Display Sponsored Effort",
	sponsoredEffortRequiredTitle: "Sponsored Effort required",
	sponsoredEffortRequiredDescription: "Sponsored Effort required",
	costShareEffortTitle: "Display Cost Share Effort",
	costShareEffortDescription: "Display Cost Share Effort",
	costShareEffortRequiredTitle: "Cost Share Effort required",
	costShareEffortRequiredDescription: "Cost Share Effort required",
	defaultEffortFormatTitle: "Default effort format",
	defaultEffortFormatDescription: "Default effort format"
};

const EFFORT_FORMATS = [{
	id: "Percentage",
	text: "Percentage",
	value: "Percentage"
},
{
	id: "Months",
	text: "Months",
	value: "Months"
}];

export const ReserchTeamCustomSettings = ({ parentQuestionConfig, onChangeConfig }) => {
	const dictionary = useDictionary("simplifiedBuilder.components.researchTeam");
	const extraSettings = parentQuestionConfig.extraSettings;
	
	const onChangeExtraSettings = newExtraSettings => onChangeConfig({
		extraSettings: { ...extraSettings, ...newExtraSettings },
	});

	const onCheckboxChange = (event, data) => onChangeExtraSettings({ [data.name]: data.checked });

	const onEffortFormatChange = (event, data) => onChangeExtraSettings({ defaultEffortFormat: data.value });

	return (
		<>
			<label className={`ui input ${styles.extraSettingsSetting}`}>
				<Checkbox
					label={dictionary.externalResearchersTitle || DEFAULT_DICTIONARY.externalResearchersTitle}
					checked={extraSettings.externalResearchers}
					name="externalResearchers"
					onChange={onCheckboxChange}
					data-testid="external-researchers"
				/>
			</label>
			{extraSettings.externalResearchers && <label className={`ui input ${styles.subItem}`}>
				<Checkbox
					label={dictionary.allowNewPerson || DEFAULT_DICTIONARY.allowNewPerson}
					checked={extraSettings.allowNewPerson}
					name="allowNewPerson"
					onChange={onCheckboxChange}
					data-testid="allow-new-person"
				/>
			</label>}
			<label className={`ui input ${styles.extraSettingsSetting}`}>
				<Checkbox
					label={dictionary.creditFieldTitle || DEFAULT_DICTIONARY.creditFieldTitle}
					checked={extraSettings.creditField}
					name="creditField"
					onChange={onCheckboxChange}
					data-testid="credit-field"
				/>
			</label>
			{parentQuestionConfig.isRequired && extraSettings.creditField && <label className={`ui input ${styles.subItem}`}>
				<Checkbox
					label={dictionary.creditFieldRequiredTitle || DEFAULT_DICTIONARY.creditFieldRequiredTitle}
					checked={extraSettings.creditFieldRequired}
					name="creditFieldRequired"
					onChange={onCheckboxChange}
					data-testid="credit-field-required"
				/>
			</label>}
			<label className={`ui input ${styles.extraSettingsSetting}`}>
				<Checkbox
					label={dictionary.sponsoredEffortTitle || DEFAULT_DICTIONARY.sponsoredEffortTitle}
					checked={extraSettings.sponsoredEffort}
					name="sponsoredEffort"
					onChange={onCheckboxChange}
					data-testid="sponsored-effort"
				/>
			</label>
			{parentQuestionConfig.isRequired && extraSettings.sponsoredEffort && <label className={`ui input ${styles.subItem}`}>
				<Checkbox
					label={dictionary.sponsoredEffortRequiredTitle || DEFAULT_DICTIONARY.sponsoredEffortRequiredTitle}
					checked={extraSettings.sponsoredEffortRequired}
					name="sponsoredEffortRequired"
					onChange={onCheckboxChange}
					data-testid="sponsored-effort-required"
				/>
			</label>}
			<label className={`ui input ${styles.extraSettingsSetting}`}>
				<Checkbox
					label={dictionary.costShareEffortTitle || DEFAULT_DICTIONARY.costShareEffortTitle}
					checked={extraSettings.costShareEffort}
					name="costShareEffort"
					onChange={onCheckboxChange}
					data-testid="cost-share-effort"
				/>
			</label>
			{parentQuestionConfig.isRequired && extraSettings.costShareEffort && <label className={`ui input ${styles.subItem}`}>
				<Checkbox
					label={dictionary.costShareEffortRequiredTitle || DEFAULT_DICTIONARY.costShareEffortRequiredTitle}
					checked={extraSettings.costShareEffortRequired}
					name="costShareEffortRequired"
					onChange={onCheckboxChange}
					data-testid="cost-share-effort-required"
				/>
			</label>}
			{(extraSettings.sponsoredEffort || extraSettings.costShareEffort) && <label className={`ui input ${styles.extraSettingsSetting}`}>
				<label>
					{dictionary.defaultEffortFormatTitle || DEFAULT_DICTIONARY.defaultEffortFormatTitle}
				</label>
				<Dropdown
					selection
					options={EFFORT_FORMATS}
					value={extraSettings?.defaultEffortFormat ?? EFFORT_FORMATS[0].id}
					onChange={onEffortFormatChange}
				/>
			</label>}
		</>
	);
};
